// StandAloneCover.jsx
import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './styles'
import { getCardSuccess } from 'src/reducers/card/action'
import { sectionDrawerOpen } from 'src/reducers/course/action'
const StandAloneCover = props => {
  const { classes } = props
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const course = useSelector(state => state.course.course)
  const open = useSelector(state => state.course.sectionDrawerOpen)

  const searchParams = new URLSearchParams(location.search)
  const pageId = searchParams.get('page')
  const isActive = pageId === 'cover'

  const onClickCover = () => {
    dispatch(sectionDrawerOpen())
  }

  return (
    <div
      className={`${classes.standAloneCoverDiv} ${
        isActive ? classes.activePage : ''
      }`}
      onClick={onClickCover}
    >
      <div
        className={classes.contentWrapper}
        style={{
          justifyContent: open ? 'flex-start' : 'center',
        }}
      >
        <div className={classes.iconContent}>
          <Icon icon="tabler:menu-2" className={classes.icons} />
        </div>
        <div
          style={{
            width: open ? '100%' : '0px',
            overflow: 'hidden',
            transition: 'all 0.3s',
          }}
        >
          <Typography id="cover-page" className={classes.pageText}>
            Table of content
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(StandAloneCover)
